import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

interface CategoryNavProps {
  activeSlug?: string;
}

export default function CategoryNav({ activeSlug = 'all' }: CategoryNavProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto scrollbar-hide flex-wrap">
      {categories.map((cat) => (
        <Link
          key={cat.id}
          to={`/category/${cat.slug}`}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
          }`}
        >
          <i className={`${cat.icon} text-sm`}></i>
          {cat.name}
        </Link>
      ))}
    </div>
  );
}